<template>
  <v-layout row justify-start class="toolbar-container">
    <slot />
  </v-layout>
</template>

<script>
export default {
  name: "HomeFormTableToolbar"
};
</script>

<style scoped>
.toolbar-container {
  width: 100%;
  background-color: #f0f0ef;
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.15);
  flex-wrap: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Forms/_Atoms/TableToolbar.vue